// Side-effect import — registers Inter font family globally
import "../../pdf-components/PdfFonts";

import { Document } from "@react-pdf/renderer";
import { formatToYYYY_MMM_DD } from "../../../../helpers/functions";
import { PdfPage1 } from "./PdfPage1";
import { PdfPage2 } from "./PdfPage2";
import { PdfPage3 } from "./PdfPage3";

/**
 * InterventionCommunicationFormPDF
 *
 * Root PDF Document for the Intervention Communication Form.
 * Renders 3 explicit pages with shared fixed header/footer.
 *
 * Props (all pre-computed in InterventionForm.jsx — no Redux hooks needed):
 *   pharmacyName, pharmacyStoreNumber, pharmacyPhone, pharmacyFax, pharmacyEmail
 *   patient
 *   clinicalServiceName
 *   clinicalServiceTypeCode
 *   startDateTime          — raw datetime string for the service date
 *   documentation          — formRoot?.notification
 *   intervention
 *   clinicalAssessment
 *   preAssessment
 *   interventionDetails
 *   interventionType
 *   pharmacistFollowUp
 *   prescriberFollowUp
 *   amrMedicationRow       — pre-computed or null
 *   pharmacistName
 *   pharmacistLicenseNumber
 */
export const InterventionCommunicationFormPDF = ({
  pharmacyName = "",
  pharmacyStoreNumber = "",
  pharmacyPhone = "",
  pharmacyFax = "",
  pharmacyEmail = "",
  patient = {},
  clinicalServiceName = "",
  clinicalServiceTypeCode = "",
  startDateTime = "",
  documentation = {},
  intervention = null,
  clinicalAssessment = {},
  preAssessment = {},
  interventionDetails = {},
  interventionType = null,
  pharmacistFollowUp = {},
  prescriberFollowUp = {},
  amrMedicationRow = null,
  pharmacistName = "",
  pharmacistLicenseNumber = "",
  currentLoggedInUserDetail = null,
  pharmacyStores = [],
}) => {
  // Shared pharmacy props passed down to every page header
  const pharmacyProps = {
    pharmacyName,
    pharmacyStoreNumber,
    pharmacyPhone,
    pharmacyFax,
    pharmacyEmail,
  };

  const serviceDate = startDateTime ? formatToYYYY_MMM_DD(startDateTime) : "";

  return (
    <Document
      title="Intervention Communication Form"
      author="HealthCompass"
      subject="Intervention Communication"
    >
      <PdfPage1
        pharmacyProps={pharmacyProps}
        serviceDate={serviceDate}
        patient={patient}
        clinicalServiceName={clinicalServiceName}
        documentation={documentation}
        clinicalAssessment={clinicalAssessment}
        interventionDetails={interventionDetails}
        interventionType={interventionType}
        clinicalServiceTypeCode={clinicalServiceTypeCode}
        intervention={intervention}
        amrMedicationRow={amrMedicationRow}
        pharmacistFollowUp={pharmacistFollowUp}
        pharmacistLicenseNumber={pharmacistLicenseNumber}
        currentLoggedInUserDetail={currentLoggedInUserDetail}
        pharmacyStores={pharmacyStores}
      />

      <PdfPage2
        pharmacyProps={pharmacyProps}
        serviceDate={serviceDate}
        patient={patient}
        pharmacistFollowUp={pharmacistFollowUp}
        prescriberFollowUp={prescriberFollowUp}
        pharmacistName={pharmacistName}
        pharmacistLicenseNumber={pharmacistLicenseNumber}
      />

      <PdfPage3
        pharmacyProps={pharmacyProps}
        serviceDate={serviceDate}
        patient={patient}
        documentation={documentation}
      />
    </Document>
  );
};
